import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/leilei/Documents/wahala/valjratt/school-finder/app/skola/enhet/[seoSlug]/ClientSchoolPage.tsx");
